import React from 'react';
import clsx from 'clsx';
export default function Button({ className, children, ...props }) {
  return (
    <button {...props} type="button" class={clsx('text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300', className, props.disabled && 'disabled:border-gray-400 disabled:text-gray-400')}>
      {children}
    </button>
  );
}
